import { apiConfig } from "../../apiConfig";
import { buildAuthHeader } from "../AxiosClient";

export async function getTenants() {
    let headers = {};
    try {
        headers = {
            "Authorization": await buildAuthHeader(),
            "Content-Type": "application/json"
        };
    } catch (e) {
        console.error("Error building auth header", e);
    }

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(apiConfig.endpoints.baseUrl + apiConfig.endpoints.tenants.getAll, options)
        .then(async response => {
            if (!response.ok) {
                const text = await response.text();
                throw new Error(`Request failed with status ${response.status}: ${text}`);
            }
            return response.json();
        })
        .catch(error => console.error(error));
}